import { Components } from '@mui/material'

export const MenuOverrides = (): Components['MuiMenu'] => ({
  defaultProps: {},
  styleOverrides: {
    root: {},
  },
})
